import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['part'];

  markAnswered(partId) {
    const part = this._findPart(partId);

    if (!part) {
      return;
    }

    part.querySelector('[data-icon-answered]')?.classList.remove('hidden');
    this._pendingIcon(part)?.classList.add('hidden');
  }

  markUnanswered(partId) {
    const part = this._findPart(partId);

    if (!part) {
      return;
    }

    part.querySelector('[data-icon-answered]')?.classList.add('hidden');
    this._pendingIcon(part)?.classList.remove('hidden');
  }

  // The server renders exactly one not-answered icon per part: the plain circle for
  // a question still ahead of the learner, or the skipped cross for a required one
  // they already moved past.
  _pendingIcon(part) {
    return part.querySelector('[data-icon-unanswered], [data-icon-skipped]');
  }

  _findPart(partId) {
    return this.partTargets.find((t) => t.dataset.partId === String(partId));
  }
}
